import React from 'react';
import './CoachingAgendaEmpty.styl';
import ManagerRecommendedCoaching from 'components/dashboard/manager/ManagerRecommendedCoaching';
import Button from '@material-ui/core/Button';

export default class CoachingAgendaEmpty extends React.PureComponent {
  render() {
    const {noPreviousPlans, hideSuggested} = this.props;

    return (
      <div className="coaching-agenda-empty">
        <div className="empty-content">
          <div>
            <h2 className="title">Coaching Meetings</h2>
            <div className="empty-agenda-cta">
              {noPreviousPlans ? (
                <div>
                  It doesn't seem like you are using the coaching plan features. Contact your
                  account executive for a demonstration to get started.
                </div>
              ) : (
                <div>
                  Setting up Coaching Plans can help you develop your team's skills and improve
                  outcomes.
                  <div className="learn-more">
                    <Button
                      component="a"
                      variant="contained"
                      color="primary"
                      className="ev-button"
                      href="https://support.mediafly.com/hc/en-us/articles/13491856461723-Coach-View#h_01GV0TW7FV2J9XZFX0150VJZKN"
                      target="_blank"
                      rel="noreferrer">
                      Learn More
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        {!hideSuggested && (
          <ManagerRecommendedCoaching
            {...this.props}
            listColumn={true}
            numActionsShown={2}
            title="Recommended Coaching"
          />
        )}
      </div>
    );
  }
}
